import { render, staticRenderFns } from "./PatientControlReservation.vue?vue&type=template&id=026f6648&scoped=true&"
import script from "./PatientControlReservation.vue?vue&type=script&lang=ts&"
export * from "./PatientControlReservation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026f6648",
  null
  
)

export default component.exports